import { Expose, Type } from 'class-transformer'
import { ValidateNested } from 'class-validator'
import { Dealership } from '../../entity/dealership.entity'

export class DealershipDTO {
    @Expose()
    @ValidateNested()
    @Type(() => Dealership)
    dealership!: Dealership
}
